import * as React from 'react';
import * as ReactDOM from 'react-dom';
import Helpers from './app/helpers';
import { ParseConfig } from './configs';
import registerServiceWorker from './registerServiceWorker';
import Routes from './routes';

ParseConfig.initialize();
// tslint:disable-next-line:no-unused-expression
new Helpers();

ReactDOM.render(
  <Routes />,
  document.getElementById('root') as HTMLElement
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.tsx